import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Table, Tag } from "antd";
import type { ColumnsType } from "antd/es/table";
import { MentorshipApprovedDataType } from "../Types/DataType";
import { isAuth } from "../../../auth/ProtectedRoute";
import SkeletonTable, {
  SkeletonTableColumnsType,
} from "../../../../components/SkeletonTable";
import axios from "axios";

const MentorshipApprovedTable = (props: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [mentorshipData, setMentorshipData] = useState<MentorshipApprovedDataType[]>([]);
  const [showTotal, setShowTotal] = useState<number>(0);

  const showMentorshipTable = (page: number) => {
    setLoading(true);
    axios({
      method: "GET",
      url: process.env.REACT_APP_HOST_API + `mentor-profiles?status=approved&page=${page}`,
      headers: {
        Authorization: `Bearer ${isAuth()}`,
      },
    })
      .then((res) => {
        setLoading(false);
        if (res.data.response === true && res.data.status === 200) {
          const mappedData = res.data.data.data.map((item: any) => ({
            key: item.member_id,
            id: item.member_id,
            applicant: {
              fullname: item.full_name || `Member ${item.member_id}`,
              image: item.profile_picture ? process.env.REACT_APP_IMAGE_API_PREFIX + item.profile_picture : null,
            },
            position: {
              role: item.target_roles ? item.target_roles[0] : "N/A",
            },
            experience: `${item.experience_years || 0} Years`,
            date: new Date(item.created_at).toLocaleDateString("en-US", {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            }),
            status: "Approved",
          }));
          setMentorshipData(mappedData);
          setShowTotal(res?.data?.data?.pagination?.total || 0);
          if (props.getApprovedTotal) {
            props.getApprovedTotal(res?.data?.data?.pagination?.total || 0);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    showMentorshipTable(1);
  }, []);

  const columns: ColumnsType<MentorshipApprovedDataType> = [
    {
      title: "Applicant",
      dataIndex: "applicant",
      render: ({ fullname, image }) => (
        <div className="user-area" style={{ alignItems: "center", display: "flex" }}>
          <ImageContainer style={{ background: !image ? "#4895EF" : "transparent" }}>
            {image ? (
              <img
                src={image}
                alt="user"
                style={{ width: "100%", height: "100%", borderRadius: "50%" }}
              />
            ) : (
              <span style={{ color: "#FFF", fontSize: "18px", fontWeight: "bold" }}>
                {fullname.charAt(0).toUpperCase()}
              </span>
            )}
          </ImageContainer>
          <p className="user_name" style={{ margin: 0, fontWeight: 500 }}>{fullname}</p>
        </div>
      ),
    },
    {
      title: "Position",
      dataIndex: "position",
      render: ({ role }) => (
        <div>
          <p className="user_name" style={{ margin: 0, fontWeight: 500 }}>{role}</p>
        </div>
      ),
    },
    {
      title: "Experience",
      dataIndex: "experience",
      render: (text) => <p className="user_name" style={{ margin: 0 }}>{text}</p>,
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (text) => <p className="user_name" style={{ margin: 0 }}>{text}</p>,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => (
        <Tag color="blue" style={{ borderRadius: "10px", padding: "2px 10px" }}>
          {text}
        </Tag>
      ),
    },
  ];

  return (
    <SkeletonTable
      loading={loading}
      columns={columns as SkeletonTableColumnsType[]}
    >
      <Table
        columns={columns}
        dataSource={mentorshipData}
        pagination={{
          showSizeChanger: false,
          pageSize: 15,
          total: showTotal,
          onChange: (page) => {
            showMentorshipTable(page);
          },
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
      />
    </SkeletonTable>
  );
};

const ImageContainer = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-right: 20px;
`;

export default MentorshipApprovedTable;
